export default ({ request }) => ({
  // Goods
  orderGoodsListApi(data = {}) {
    return request({
      url: '/factory/order/goods/list',
      method: 'post',
      data,
    })
  },
  orderGoodsBatchListApi(data = {}) {
    return request({
      url: '/factory/order/goods/batch/list',
      method: 'post',
      data,
    })
  },
  orderGoodsDetailApi(data = {}) {
    return request({
      url: '/factory/order/goods/detail',
      method: 'post',
      data,
    })
  },
  orderGoodsCopyDetailApi(data = {}) {
    return request({
      url: '/factory/order/goods/copy/detail',
      method: 'post',
      data,
    })
  },
  orderGoodsSaveApi(data = {}) {
    return request({
      url: '/factory/order/goods/save',
      method: 'post',
      data,
      timeout: 30 * 1000,
    })
  },
  orderGoodsAddSaveApi(data = {}) {
    return request({
      url: '/factory/order/goods/add/save',
      method: 'post',
      data,
      timeout: 30 * 1000,
    })
  },
  orderGoodsDelApi(data = {}) {
    return request({
      url: '/factory/order/goods/del',
      method: 'post',
      data,
      timeout: 30 * 1000,
    })
  },
  orderGoodsUpdateSortApi(data = {}) {
    return request({
      url: '/factory/order/goods/updateSort',
      method: 'post',
      data,
    })
  },
  // Goods-Spec
  orderGoodsSpecListApi(data = {}) {
    return request({
      url: '/factory/order/goods/spec/list',
      method: 'post',
      data,
    })
  },

  orderGoodsSpecProofingListApi(data = {}) {
    return request({
      url: '/factory/order/goods/ProofingSpec/detail',
      method: 'post',
      data,
    })
  },
  orderGoodsSpecDetailApi(data = {}) {
    return request({
      url: '/factory/order/goods/spec/detail',
      method: 'post',
      data,
    })
  },
  orderGoodsSpecSaveApi(data = {}) {
    return request({
      url: '/factory/order/goods/spec/save',
      method: 'post',
      data,
    })
  },
  orderGoodsSpecDelApi(data = {}) {
    return request({
      url: '/factory/order/goods/spec/del',
      method: 'post',
      data,
    })
  },
  // Goods-Package
  // 订单产品包装选项查询
  orderGoodsPackageItemSelectApi(data = {}) {
    return request({
      url: '/master/material/info/list',
      method: 'post',
      data,
    })
  },
  orderGoodsPackageListApi(data = {}) {
    return request({
      url: '/factory/order/goods/package/list',
      method: 'post',
      data,
    })
  },
  orderGoodsPackageDetailApi(data = {}) {
    return request({
      url: '/factory/order/goods/package/detail',
      method: 'post',
      data,
    })
  },
  orderGoodsPackageOrderByListApi(data = {}) {
    return request({
      url: '/factory/order/goods/package/orederByList',
      method: 'post',
      data,
    })
  },
  orderGoodsPackageSaveApi(data = {}) {
    return request({
      url: '/factory/order/goods/package/save',
      method: 'post',
      data,
    })
  },
  orderGoodsPackageDelApi(data = {}) {
    return request({
      url: '/factory/order/goods/package/del',
      method: 'post',
      data,
    })
  },
  orderGoodsSelectImageApi(data = {}) {
    return request({
      url: '/factory/order/goods/selectImages',
      method: 'post',
      data,
    })
  },
  orderGoodsImageUploadApi(data = {}) {
    return request({
      url: '/factory/order/goods/image/uploadToGoods',
      method: 'post',
      data,
    })
  },
  orderGoodsSpecImageUploadApi(data = {}) {
    return request({
      url: '/factory/order/goods/image/uploadToGoodsSpec',
      method: 'post',
      data,
    })
  },
  orderGoodsImageDelApi(data = {}) {
    return request({
      url: '/factory/order/goods/image/del',
      method: 'post',
      data,
    })
  },
  orderGoodsSetDefaultImageApi(data = {}) {
    return request({
      url: '/factory/order/goods/setDefaultImages',
      method: 'post',
      data,
    })
  },
  orderGoodsSpecSetDefaultImageApi(data = {}) {
    return request({
      url: '/factory/order/goods/spec/setDefaultImages',
      method: 'post',
      data,
    })
  },
  orderGoodsModifyAllowApi(orderGoodsCode) {
    return request({
      url: '/factory/order/goods/modifyAllow',
      method: 'GET',
      params: { orderGoodsCode },
    })
  },
})
